import { PageCollapsibleBlock, PortalUrls } from '@servicetitan/cp-ui';
import { FC } from 'react';
import { EstimateContainerType, EstimateContainerWebModel } from '../../api/portal-dashboard.api';
import { ProposalsList } from './proposals-list/proposals-list';

interface DashboardProposalsProps {
    loading: boolean;
    filtered: boolean;
    proposals?: EstimateContainerWebModel[];
    className?: string;
    resetFilters(): void;
}

export const DashboardProposals: FC<DashboardProposalsProps> = props => {
    const { className, filtered, loading, proposals, resetFilters } = props;

    const allProposalsHref = PortalUrls.proposals.root;
    const hasContracts = proposals?.some(
        p => p.estimateContainerType === EstimateContainerType.ContractProposal
    );

    return (
        <PageCollapsibleBlock
            icon="proposal"
            title={hasContracts ? 'Contracts' : 'Proposals'}
            count={proposals?.length ?? 0}
            allRecordsHref={allProposalsHref}
            loading={loading}
            className={className}
            data-tracking-component="portal-dashboard-proposals"
            data-cy="dashboard-proposals"
        >
            <ProposalsList filtered={filtered} proposals={proposals} resetFilters={resetFilters} />
        </PageCollapsibleBlock>
    );
};
